/**
 * Where a non-trainer is sent: the MoveBuddy mobile app.
 *
 * Two screens point at it — the sign-up role step's "I have a trainer" branch, and the refusal a
 * signed-in client reaches. Both read this list, so the app is described in one place.
 *
 * The two public listings — the same URLs the invitation mail's store badges and `public/confirm.js`
 * carry. They were empty here until 24 September 2026, when the web app began stopping signed-in
 * visitors on a phone and sending them to the app, which needs somewhere to send them.
 */

export interface MobileAppStore {
  /** Identifies the store to React and picks the label. */
  id: 'ios' | 'android';
  /** Key in the web-only bundle — `web:mobileOnly.store.<id>`. */
  labelKey: string;
  url: string;
}

export const MOBILE_APP_STORES: readonly MobileAppStore[] = [
  { id: 'ios', labelKey: 'web:mobileOnly.store.ios', url: 'https://apps.apple.com/app/id6799197683' },
  {
    id: 'android',
    labelKey: 'web:mobileOnly.store.android',
    url: 'https://play.google.com/store/apps/details?id=com.movebuddy.app',
  },
];
